import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Image, SingleLineCaption } from './../../../components';
import ProjectDetailCaption from './../../../components/ProjectDetailCaption';
import { breakpoints } from './../../../styles/theme.json';

const GridItem = (props) => (
  <div className={'flexible-image-wrapper'}>
    {
      (props.window_width >= breakpoints.desktop)
      ? <Fragment>
          <ProjectDetailCaption ProjectName={props.ImgData.image.metadata.title} ImageDescription={props.ImgData.image.metadata.caption} ExpandIcon={false}/>
          <div className={'image-inner'}>
            { (props.ImgSize == 'full_row')
              ? <Image source={props.ImgData.image.urls.large}/> :
              (props.ImgSize == 'full_bleed')
              ? <Image source={props.ImgData.image.urls.large}/>
              : <Image source={props.ImgData.image.urls.small}/>
            }
            <div className={'gradient-wrapper'}>
              <div className={'bg-gradient'} />
            </div>
          </div>
        </Fragment>
      : <Fragment>
          <div className={'image-inner'}>
            <Image source={props.ImgData.image.urls.small} />
          </div>
          <SingleLineCaption Headline={props.ImgData.image.metadata.title} Description={props.ImgData.image.metadata.caption} Stacked={true} />
        </Fragment>
    }
  </div>
);

export default connect(
  state => ({
    window_width: state.window_dimensions.window_width
  })
)(GridItem);



// WEBPACK FOOTER //
// ./src/pages/blog/blog_single/grid_item.js